import api from '~/api';
import { PageResponse } from '../../../../_shared/data/dto/PageResponse';
import { Page } from '../../../../_shared/data/models/Page';
import { CustomerResponse, CustomerStatusResponse } from '../dtos/customersResponse';
import { Customers, type CustomersStatus } from '../models/customers.model';

const StatusMap: Record<CustomerStatusResponse, CustomersStatus> = {
  churned: 'Churned',
};

export async function getChurnedCustomers(
  partnerId: string,
  { page, search }: { page: number; search: string }
): Promise<Page<Customers>> {
  const { data } = await api.get<PageResponse<CustomerResponse>>(
    `v2/partner/${partnerId}/customers?status=churned&page=${page}&search=${search}&ordered_by=created&ordered_type=desc`
  );

  const customers = data.result.map(
    (customers) =>
      new Customers(
        customers.business_name,
        StatusMap[customers.onboarding_status],
        customers.plan.name
      )
  );

  return {
    items: customers,
    search: '',
    totalItems: data.total_count,
    current: page,
  };
}
